import {useState, useEffect} from 'react'
import './NotificationEntry.css'

export function NotificationEntry({text}: { text: string }) {
    const [currentState, setState] = useState("notification-started");

    useEffect(() => {
        setTimeout(() => {setState("notification-showing")}, 0);
        setTimeout(() => {setState("notification-hidden")}, 5000);
        setTimeout(() => {setState("notification-gone")}, 6000);
    }, []);

    return (
        <div className={"notification " + currentState}>
            <span className="notification-text">{text}</span>
        </div>
    );
}